
riot.tag2('product-new-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Добавить новый товар</div>\n    </yield>\n    <yield to="body">\n      <form onchange="{change}" onkeyup="{change}">\n        <div class="form-group {has-error: error.name}">\n          <label class="control-label">Наименование</label>\n          <input class="form-control" name="name" type="text">\n          <div class="help-block">{error.name}</div>\n        </div>\n      </form>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit}" type="button">Сохранить</button>\n    </yield>\n  </bs-modal>\n', '', '', function(opts) {
'use strict';

var self = this;

self.on('mount', function () {
    var modal = self.tags['bs-modal'];

    modal.item = {};
    modal.mixin('validation');
    modal.mixin('change');

    modal.rules = {
        name: 'empty'
    };

    modal.afterChange = function (e) {
        modal.error = modal.validation.validate(modal.item, modal.rules, e.target.name);
    };
});
});


// WEBPACK FOOTER //
// ./pages/products/products/product-new-modal.tag